import classNames from 'classnames';
import React from 'react';
import * as styles from './Shortcut.module.scss';
import SVGIcon from '../../components/SVGIcon';
import { IS_APPLE } from '../../constants/os';
import addIcon from '../../icons/non-prefilled/16x16/add.svg';
import mentionIcon from '../../icons/non-prefilled/16x16/mention.svg';
import returnIcon from '../../icons/non-prefilled/16x16/return.svg';
import shiftKeyIcon from '../../icons/non-prefilled/16x16/shiftKey.svg';

const KEY_MAP: Record<string, React.ReactNode> = {
  mod: IS_APPLE ? '⌘' : 'Ctrl',
  option: IS_APPLE ? '⌥' : 'Alt',
  shift: <SVGIcon size={12}>{shiftKeyIcon}</SVGIcon>,
  enter: <SVGIcon size={12}>{returnIcon}</SVGIcon>,
  '+': <SVGIcon size={12}>{addIcon}</SVGIcon>,
  '@': <SVGIcon size={12}>{mentionIcon}</SVGIcon>,
  space: 'Space',
};

interface ShortcutProps {
  keys?: string;
  small?: boolean;
}

const Shortcut = ({ keys, small }: ShortcutProps) => {
  const keyTokens = keys?.split(/(\+)/g).filter(Boolean);
  return (
    <div className={styles.shortcut}>
      {keyTokens &&
        keyTokens.length > 0 &&
        keyTokens.map((token, index) => {
          // Skip '+' characters, but allow the escape sequence '++'
          // if '+' sign needs to be displayed to the user
          if (token === '+' && keyTokens[index - 1] !== '+') {
            return null;
          }

          return (
            <kbd
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className={classNames({
                [styles.isSmall]: small,
                [styles.isMono]: /^[0-9a-z]$/.test(token),
              })}
            >
              {KEY_MAP[token] ?? token}
            </kbd>
          );
        })}
    </div>
  );
};

export default Shortcut;
